import { SaleCostType, SalesGroupDetails } from 'src/WebApiController';

/**
 * Total tax for a sales group: the sum of earning lines whose cost type is Taxes,
 * as a positive magnitude.
 *
 * Tax is charged to the buyer on top of the subtotal, but the backend's `pandL`
 * (Subtotal − TotalCost + Charges − Credits) and `balanceDue`
 * (Subtotal + Charges − Credits − PaymentReceived) exclude it — both are built
 * from Sale.Charges/Credits, which do not include tax. Tax instead surfaces as an
 * earning line (backend maps MarketplacePaymentLineType.Tax → SaleCostType.Taxes),
 * so callers add this back as a positive amount for P&L.
 *
 * NOTE: tax is NOT reliably present in `aggregatedPaymentLines` — the backend
 * groups those by (paymentRef | currency | state), a key that omits the line
 * type, so a Tax line is collapsed into its transaction's row. `earningLines` is
 * the authoritative, per-cost-type source (and the one the Earnings table renders).
 */
export function getGroupTaxAmount(group: SalesGroupDetails): number {
  return (group.earningLines ?? [])
    .filter((line) => line.costType === SaleCostType.Taxes)
    .reduce((sum, line) => sum + Math.abs(line.amount?.amt ?? 0), 0);
}
